import Menu from 'types/Menu'

const useMenus = (): { data: Menu[]; isValidating: boolean; error: Error | null; result: any } => {
  const womenMenu = {
    placement: 'top-side',
    platform: 'desktop',
    text: 'Women',
    url: '/collections/womens-all',
    categories: [],
  }

  const menMenu = {
    placement: 'top-side',
    platform: 'desktop',
    text: 'Men',
    url: '/collections/shop-all-mens-clothing',
    categories: [],
  }

  const everworldMenu = {
    placement: 'top-side',
    platform: 'desktop',
    text: 'Everworld Stories',
    url: '/everworld',
    categories: [],
  }

  return {
    data: [womenMenu, menMenu, everworldMenu],
    isValidating: false,
    error: null,
    result: null,
  }
}

export default useMenus
